module.exports = __webpack_public_path__ + "img/logout.d5cf608d.svg";